import React from 'react';
import { connect } from 'react-redux'
import { Tree } from 'antd';
import { DMLActions } from '../../redux';

const { TreeNode } = Tree;

class FileSelectPage extends React.Component {
  state = {
    treeData: [
      { title: 'NODE0', key: '0' },
      { title: 'NODE1', key: '1', isLeaf: true },
    ],
  };

  onLoadData = treeNode =>
    new Promise(resolve => {
      if (treeNode.props.children) {
        resolve();
        return;
      }
      this.props.dispatch(DMLActions.loadChildern(treeNode.props.dataRef.folderId))
      .then(response => {
        console.log("result", response);
        this.setState({sub:response});
        resolve();
        return;
      })
    });

  renderTreeNodes = data =>
    data.map(item => {
      if (item.children) {
        return (
          <TreeNode title={(item.fileName)?item.fileName:item.name} key={item.uuid} dataRef={item} isLeaf={(item.fileName)?true:false}>
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode title={(item.fileName)?item.fileName:item.name} key={item.uuid} dataRef={item} isLeaf={(item.fileName)?true:false}/>;
    });

  onSelect = (selectedKeys, info) => {
    if (this.props.onSelect){
      this.props.onSelect(selectedKeys, info)
    }
    this.props.dispatch(DMLActions.SELECTED(info.node.props.dataRef));
  };

  render() {
    //console.log(this);
    return <Tree  onSelect={this.onSelect} loadData={this.onLoadData}>{this.renderTreeNodes(this.props.nodes)}</Tree>;
  }
}

export default connect(
  (state, props) => {
    const {vset, ldml} = state;
    const {lang, graph } = props;
    return ({
      lang: (lang)?lang: vset.lang,
      graph: (graph)?graph: vset.graph,
      nodes: (ldml.items)?ldml.items:[],
    })
  },
  null //dispatch => ({})
)(FileSelectPage)
